import cloneDeep from 'lodash/cloneDeep';
import buildIntegrationConnection from 'app/shared/translation/integrations/buildIntegrationConnection';
import translatePlaybookJson from 'app/shared/translation/integrations/translatePlaybookJson';
import buildIntegrationConsent from './buildIntegrationConsent';

export default function translatePipelineIntegration(pipelineIntegration) {
  const { pipelineIntegrationConsent } = pipelineIntegration;
  const { playbook, pipelineVars, id } = pipelineIntegration.stagedRevision;
  const {
    revision,
    vars,
    playbookJson,
    connectionJson,
    integration: { starterkitId, id: integrationId },
    pipeline_variables,
  } = playbook;
  const { connectionType, connection } = buildIntegrationConnection({
    connectionJson,
    vars,
    pipelineVars,
    pipelineVariables: pipeline_variables,
    starterkitId,
  });

  /**
   * Playbook version gets added to JSON here in order to get the correct value from the auto-incremented
   * DB revision column, otherwise it would need to be calculated client-side before inserting the playbook.
   */
  const mutablePlaybook = cloneDeep(playbookJson);
  mutablePlaybook.version = String(revision);

  // (EunHye 2023.02.28) - line 25 is necessary for backwards compatability
  const integrationJson = {
    ...(connectionType === 'endpointSchema' && { connection: { params: [] } }),
    [connectionType]: connection,
    integrationName: starterkitId,
    id: integrationId,
    disabled: pipelineIntegration.disabled,
    revision: {
      id: id,
    },
    transformStages: [
      {
        data: {
          playbook: translatePlaybookJson({
            playbookJson: mutablePlaybook,
            deprecatedPipelineVariables: vars,
            pipelineVars,
            playbookPipelineVariables: pipeline_variables,
          }),
        },
        name: starterkitId,
        desc: `pipeline for ${starterkitId} integration`,
      },
    ],
  };

  const consent = buildIntegrationConsent(pipelineIntegrationConsent);
  if (consent) {
    integrationJson.consent = consent;
  }

  return integrationJson;
}
